import { getUserToken, putMeApi } from "../api/users.ts";
import { clearUserForErrorLogging } from "./error-utils";
import { isBrowser, removeItemFromLocalStorage } from "./miscellaneous-util";
import { cognitoLogout } from "./user-auth-provider";
import { sentryService } from "./sentry-service";

export const getViewAsUserId = () =>
  (isBrowser() && window.localStorage.getItem("view-as-user")) || "";

export const isTokenAvailable = () => {
  if (isBrowser()) {
    return !!window.localStorage.getItem("token");
  }
  return false;
};

export const getCsrfToken = async () => {
  const userIndex = await getUserToken();
  const { csrfToken } = userIndex;
  if (isBrowser()) {
    window.localStorage.setItem("token", csrfToken);
  }
  return csrfToken;
};

export const logout = async (redirect = "/login") => {
  await cognitoLogout().finally(() => {
    clearUserForErrorLogging();
    removeItemFromLocalStorage("viewAsUserId");
    removeItemFromLocalStorage("authUserName");
    sentryService.removeUser();
    sentryService.removeTag("company_domain");
    if (redirect) {
      window.location.href = redirect;
    }
  });
};

export const updateUserLastLoginTime = () => {
  return putMeApi({
    lastLoginTime: new Date(),
  });
};
